/** Gemara selection model — shared by both designs (editor, examine dialog, registrations). */
/** 23 המסכתות של תלמודא — מספר דפים בכל מסכתא */
export const TALMUDA_TRACTATES = {
  שבת: 157, עירובין: 105, פסחים: 121, סוכה: 56, ביצה: 40, 'ראש השנה': 35,
  יבמות: 122, כתובות: 112, נדרים: 91, נזיר: 66, סוטה: 49, גיטין: 90, קידושין: 82,
  'בבא קמא': 119, 'בבא מציעא': 119, 'בבא בתרא': 176, סנהדרין: 113, מכות: 24,
  שבועות: 49, זבחים: 120, חולין: 142, מנחות: 110, נדה: 73,
};

export const TRACTATE_NAMES = Object.keys(TALMUDA_TRACTATES);

export const EMPTY_RANGE = () => ({ from: '', to: '' });
export const EMPTY_TRACTATE_ENTRY = () => ({
  tractate: '',
  ranges: [EMPTY_RANGE()],
  examined: false,
});

/** המרת gemaraSelection מהשרת לרשומות עריכה בטופס */
export function selectionToEntries(selection) {
  const entries = (selection || []).map((sel) => ({
    tractate: sel.tractate || '',
    examined: !!sel.examined,
    ranges: sel.ranges?.length
      ? sel.ranges.map((r) => ({ from: String(r.from), to: String(r.to) }))
      : [EMPTY_RANGE()],
  }));
  return entries.length > 0 ? entries : [EMPTY_TRACTATE_ENTRY()];
}

/** בניית payload ל־API מתוך רשומות העורך */
export function entriesToSelection(entries) {
  return (entries || [])
    .filter((e) => e.tractate)
    .map((e) => ({
      tractate: e.tractate,
      examined: !!e.examined,
      ranges: (e.ranges || [])
        .filter((r) => r.from && r.to)
        .map((r) => ({ from: Number(r.from), to: Number(r.to) })),
    }))
    .filter((e) => e.ranges.length > 0);
}

/** ולידציה: מסכת + טווחים תקינים (מדף ≥ 2, from ≤ to, עד מקסימום המסכת) */
export function isGemaraEntriesValid(entries) {
  if (!entries?.length) return false;
  return entries.every((e) => {
    if (!e.tractate) return false;
    const max = TALMUDA_TRACTATES[e.tractate];
    return (e.ranges || []).every((r) => {
      const f = Number(r.from);
      const t = Number(r.to);
      if (!f || !t || f < 2 || t < 2 || f > t) return false;
      if (max && t > max) return false;
      return true;
    });
  });
}

